import {
  ArrowLeftRight,
  BookOpen,
  Boxes,
  Car,
  FileBarChart,
  FileSpreadsheet,
  FolderOpen,
  Landmark,
  LineChart,
  ListTree,
  Scale,
  Sigma,
  TrendingUp,
} from 'lucide-react';
import { PageHeader } from '@/components/page-header';
import { SidebarTabs } from '@/components/sidebar-tabs';
import { AccountsTab } from './accounting/accounts';
import { BankTab } from './accounting/bank';
import { FilesTab } from './accounting/files';
import { FixedAssetsTab } from './accounting/fixed-assets';
import { JournalTab } from './accounting/journal';
import { MileageTab } from './accounting/mileage';
import {
  BalanceSheetReport,
  IncomeStatementReport,
  RevenueReport,
  ScheduleCReport,
  TrialBalanceReport,
} from './accounting/reports';
import { TransactionsTab } from './accounting/transactions';

export function Accounting() {
  return (
    <div className="space-y-5">
      <PageHeader
        icon={BookOpen}
        title="Accounting"
        subtitle="Double-entry ledger. Every dollar maps to a Schedule C line."
      />

      <SidebarTabs
        paramName="tab"
        tabs={[
          { key: 'income-statement', label: 'Income statement', icon: FileBarChart, group: 'Reports', content: <IncomeStatementReport /> },
          { key: 'balance-sheet', label: 'Balance sheet', icon: Scale, group: 'Reports', content: <BalanceSheetReport /> },
          { key: 'schedule-c', label: 'Schedule C', icon: TrendingUp, group: 'Reports', content: <ScheduleCReport /> },
          { key: 'trial-balance', label: 'Trial balance', icon: Sigma, group: 'Reports', content: <TrialBalanceReport /> },
          { key: 'revenue', label: 'Revenue', icon: LineChart, group: 'Reports', content: <RevenueReport /> },
          { key: 'bank', label: 'Bank', icon: Landmark, group: 'Connections', content: <BankTab /> },
          { key: 'transactions', label: 'Transactions', icon: ArrowLeftRight, group: 'Connections', content: <TransactionsTab /> },
          { key: 'journal', label: 'Journal entries', icon: FileSpreadsheet, group: 'Ledger', content: <JournalTab /> },
          { key: 'accounts', label: 'Chart of accounts', icon: ListTree, group: 'Ledger', content: <AccountsTab /> },
          { key: 'files', label: 'Files', icon: FolderOpen, group: 'Ledger', content: <FilesTab /> },
          { key: 'fixed-assets', label: 'Fixed assets', icon: Boxes, group: 'Tax', content: <FixedAssetsTab /> },
          { key: 'mileage', label: 'Mileage', icon: Car, group: 'Tax', content: <MileageTab /> },
        ]}
      />
    </div>
  );
}
